import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PurchaseCalendarItemMutationVariables = Types.Exact<{
  input: Types.PurchaseCalendarItemInput;
}>;

export type PurchaseCalendarItemMutation = {
  __typename?: "Mutation";
  purchaseCalendarItem:
    | {
        __typename?: "CalendarItemPurchaseBillingFailedResult";
        message: string | null;
      }
    | {
        __typename?: "CalendarItemPurchaseBillingNeedActionResult";
        invoiceUuid: string | null;
        stripePaymentIntentClientSecret: string | null;
      }
    | {
        __typename?: "CalendarItemPurchaseBookFailedResult";
        message: string | null;
      }
    | {
        __typename?: "CalendarItemPurchaseSuccessResult";
        invoiceUuid: string | null;
      };
};

export type GetInvoicePreviewForEventQueryVariables = Types.Exact<{
  getInvoicePreviewForEventInput: Types.GetInvoicePreviewForEventInput;
}>;

export type GetInvoicePreviewForEventQuery = {
  __typename?: "Query";
  getInvoicePreviewForEvent: {
    __typename?: "InvoicePreview";
    total: number;
    discount: {
      __typename?: "InvoiceDiscount";
      amount: number;
      rate: number;
      type: string;
    } | null;
    tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
    fees: Array<{
      __typename?: "InvoiceFee";
      code: Types.InvoiceFeeCode;
      description: string | null;
      fee: number;
      rate: number | null;
    }> | null;
  };
};

export type EventInvoicePreviewFragment = {
  __typename?: "InvoicePreview";
  total: number;
  discount: {
    __typename?: "InvoiceDiscount";
    amount: number;
    rate: number;
    type: string;
  } | null;
  tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
  fees: Array<{
    __typename?: "InvoiceFee";
    code: Types.InvoiceFeeCode;
    description: string | null;
    fee: number;
    rate: number | null;
  }> | null;
};

export const EventInvoicePreviewFragmentDoc = gql`
  fragment EventInvoicePreview on InvoicePreview {
    total
    discount {
      amount
      rate
      type
    }
    tax {
      amount
      rate
    }
    fees {
      code
      description
      fee
      rate
    }
  }
`;
export const PurchaseCalendarItemDocument = gql`
  mutation PurchaseCalendarItem($input: PurchaseCalendarItemInput!) {
    purchaseCalendarItem(purchaseCalendarItem: $input) {
      ... on CalendarItemPurchaseSuccessResult {
        invoiceUuid
      }
      ... on CalendarItemPurchaseBookFailedResult {
        message
      }
      ... on CalendarItemPurchaseBillingFailedResult {
        message
      }
      ... on CalendarItemPurchaseBillingNeedActionResult {
        invoiceUuid
        stripePaymentIntentClientSecret
      }
    }
  }
`;
export type PurchaseCalendarItemMutationFn = Apollo.MutationFunction<
  PurchaseCalendarItemMutation,
  PurchaseCalendarItemMutationVariables
>;

/**
 * __usePurchaseCalendarItemMutation__
 *
 * To run a mutation, you first call `usePurchaseCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseCalendarItemMutation, { data, loading, error }] = usePurchaseCalendarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PurchaseCalendarItemMutation,
    PurchaseCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PurchaseCalendarItemMutation,
    PurchaseCalendarItemMutationVariables
  >(PurchaseCalendarItemDocument, options);
}
export type PurchaseCalendarItemMutationHookResult = ReturnType<
  typeof usePurchaseCalendarItemMutation
>;
export type PurchaseCalendarItemMutationResult =
  Apollo.MutationResult<PurchaseCalendarItemMutation>;
export type PurchaseCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  PurchaseCalendarItemMutation,
  PurchaseCalendarItemMutationVariables
>;
export const GetInvoicePreviewForEventDocument = gql`
  query GetInvoicePreviewForEvent(
    $getInvoicePreviewForEventInput: GetInvoicePreviewForEventInput!
  ) {
    getInvoicePreviewForEvent(
      getInvoicePreviewForEventInput: $getInvoicePreviewForEventInput
    ) {
      ...EventInvoicePreview
    }
  }
  ${EventInvoicePreviewFragmentDoc}
`;

/**
 * __useGetInvoicePreviewForEventQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewForEventQuery({
 *   variables: {
 *      getInvoicePreviewForEventInput: // value for 'getInvoicePreviewForEventInput'
 *   },
 * });
 */
export function useGetInvoicePreviewForEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicePreviewForEventQuery,
    GetInvoicePreviewForEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInvoicePreviewForEventQuery,
    GetInvoicePreviewForEventQueryVariables
  >(GetInvoicePreviewForEventDocument, options);
}
export function useGetInvoicePreviewForEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicePreviewForEventQuery,
    GetInvoicePreviewForEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInvoicePreviewForEventQuery,
    GetInvoicePreviewForEventQueryVariables
  >(GetInvoicePreviewForEventDocument, options);
}
export type GetInvoicePreviewForEventQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForEventQuery
>;
export type GetInvoicePreviewForEventLazyQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForEventLazyQuery
>;
export type GetInvoicePreviewForEventQueryResult = Apollo.QueryResult<
  GetInvoicePreviewForEventQuery,
  GetInvoicePreviewForEventQueryVariables
>;
